/* eslint-disable react/prop-types */
import React, { memo } from 'react';
import { areEqual } from 'react-window';

import type { GeneralLedgerListItem } from './types';

type GeneralLedgerItemRendererProps = {
  data: Array<GeneralLedgerListItem>;
  index: number;
  style: Record<string, unknown>;
};

const GeneralLedgerItemRenderer = memo<GeneralLedgerItemRendererProps>(({ data, index, style }) => {
  const { ItemComponent, itemProps } = data[index];
  return (
    <div style={style}>
      <ItemComponent {...itemProps} />
    </div>
  );
}, areEqual);

GeneralLedgerItemRenderer.displayName = 'GeneralLedgerItemRenderer';

export default GeneralLedgerItemRenderer;
